// Most doctor names are already stored with their title ("Dr NIKHIL", "DR. REMYA"), so only
// prefix "Dr." when it isn't there — otherwise the UI reads "Dr. Dr NIKHIL".
export const withDrTitle = (name) => {
  const n = (name || "").trim();
  if (!n) return "";
  return /^dr\b\.?/i.test(n) ? n : `Dr. ${n}`;
};
